var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 51,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M24.863.779c-2.85.713-19.79 13.289-19.79 13.289S-.884 16.933.282 17.824c1.187.908 5.73-.97 7.923-1.786 3.131-1.17 8.142-3.065 17.648-3.987 8.863-.859 14.618-.186 17.87.53 3.248.712 3.877-.835 3.764-2.506-.087-1.25-1.002-4.849-1.32-6.038-.327-1.216-1.3-1.62-2.027-1.986-1.504-.752-3.852-1.5-7.582-1.806a56.25 56.25 0 0 0-4.655-.207c-2.83 0-5.137.264-7.04.741z",
    id: "a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "52.279%",
    y1: "47.831%",
    x2: "43.474%",
    y2: "38.658%",
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.3,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M27.567-24.908L56.41 11.008l-37.26 32.67L-9.693 7.76z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M41.553 0v46.686H0V0h41.553z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "69.968%",
    y1: "44.026%",
    x2: "92.182%",
    y2: "8.296%",
    id: "h"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.7,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.45 18.876c-6.243 5.18-12.302 8.55-17.85 11.564C1.85 31.929 0 33.318 0 35.358c0 2.18 1.293 8.959 3.092 10.195 1.8 1.24 7.156-3.021 8.532-3.966 1.373-.939 12.859-7.663 18.153-13.27 7.12-7.54 9.624-12.624 11.285-17.454 1.66-4.83-1.203-9.424-3.839-10.366-1.39-.498-2.525-1.404-3.293-1.406-.687 0-1.077.724-1.095 3.111-.028 4.081-4.145 11.491-10.385 16.674z",
    id: "g"
  }), /*#__PURE__*/React.createElement("path", {
    id: "i",
    d: "M0 19.31V0h37.157v19.31z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(116.955 32.534)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FAE700",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#d)",
    xlinkHref: "#c"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(114 4.907)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#f)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#93C01F",
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.5,
    fill: "url(#h)",
    xlinkHref: "#g"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(118.618)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "j",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.32 7.618C1.623 8.995.401 9.7.093 11.697c-.269 1.746.104 5.495.36 6.557.255 1.065.717 1.832 3.584-.297 2.867-2.126 14.903-8.565 22.43-8.802 7.527-.235 11.43 1.99 9.398 8.47 3.117-9.483-.035-13.164-2.828-15.086C29.947.412 24.162-1.007 17.3.884 10.437 2.775 5.573 5.79 3.32 7.618",
    fill: "#0054A0",
    mask: "url(#j)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#0054A0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.474 35.794c-.834.318-1.79.583-2.685.583-1.18 0-1.746-.526-1.746-1.718 0-.333.047-.762.142-1.239l2.359-11.158h3.633a14.864 14.864 0 0 1 1.651-2.117 14.722 14.722 0 0 1 2.574-2.175H70.3l1.462-6.487-5.804 1.432-1.084 5.055h-3.868l-.945 4.292h3.917l-2.548 11.585c-.19.862-.283 1.67-.283 2.385 0 2.956 1.888 4.768 5.19 4.768 2.255 0 4.727-.486 7.165-1.655a11.2 11.2 0 0 1-2.027-3.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.91 34.935c-1.31.738-3.11 1.421-5.195 1.421-3.277 0-5.226-2.297-5.226-5.984 0-5.124 3.658-8.474 7.932-8.474 1.9 0 3.419.431 5.081 1.293l.398-1.675.654-2.939c-1.65-.755-3.353-1.227-5.99-1.227-8.645 0-13.726 6.463-13.726 13.5 0 5.841 3.372 10.15 9.309 10.15 2.128 0 4.05-.42 5.635-.998l1.129-5.067zM9.287 23.862c0-1.34 1.19-1.962 2.859-1.962 1.856 0 4.048.669 5.379 1.34l-.852-5.295a17.946 17.946 0 0 0-4.527-.595c-5.813 0-8.574 3.065-8.574 6.703 0 6.558 7.524 6.99 7.524 10.195 0 1.58-1.475 2.347-3.572 2.347-1.952 0-3.952-.86-5.572-1.963L0 38.845C2.189 40.185 4.858 41 7.859 41c5.19 0 8.906-2.44 8.906-6.942 0-6.462-7.478-6.702-7.478-10.196M40.195 40.633h-4.198s-1.909-13.372-2.101-14.756l-7.632 14.756h-4.152L18.438 17.9h5.487l1.819 14.919L33.272 17.9h3.965l2.04 14.792L46.302 17.9h5.725L40.195 40.633zM54.6 40.45h-5.676l4.913-22.55h5.675zM57.182 15.883c-2.015 0-3.512-1.523-3.512-3.573 0-2.576 2.117-4.31 4.286-4.31 2.118 0 3.564 1.63 3.564 3.522 0 2.573-2.065 4.361-4.338 4.361M111.902 29.834l-2.39 10.8h-5.782l2.963-13.287c.24-1.003.383-2.15.383-2.914 0-1.053-.48-1.958-1.961-1.958-1.959 0-6.26 2.15-7.836 9.557l-1.864 8.601h-5.782L96.815 9.1h5.687l-1.973 8.165a81.932 81.932 0 0 1-1.434 5.017h.047c2.245-2.818 5.209-4.78 8.555-4.78 3.057 0 5.303 1.53 5.303 5.114 0 1.817-.43 4.16-1.098 7.218"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.11f48fbc4f855927eb191d33bd8dca11.svg";
export { ForwardRef as ReactComponent };